import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Button, Input } from "component-library";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { Bounce, toast } from "react-toastify";
import { sendNewLead } from "../../../client/client";
import { useTranslation } from "react-i18next";
import * as Sentry from "@sentry/react";

export const ContactForm: React.FC = () => {
  const { handleSubmit, register, formState, reset } = useForm<{
    email: string;
  }>({
    defaultValues: {
      email: "",
    },
  });
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = handleSubmit((data) => {
    setIsLoading(true);
    sendNewLead(data)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to send form data");
        }
        reset();

        toast(t("pages.done.contact_form.success_message"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      })
      .catch((error) => {
        Sentry.captureMessage("Error sending form data:", error);
        toast.error(t("pages.done.contact_form.error_message"), {
          position: "top-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  });

  return (
    <form
      className="w-full flex flex-col gap-2"
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <div className="text-2xl text-text-primary mb-2 w-full text-center">
        {t("pages.done.contact_form.title")}
      </div>
      <div className="my-2 px-4 py-2 bg-white border border-gray-300 rounded-lg shadow-sm flex flex-row items-center gap-4">
        <InformationCircleIcon
          className="text-primary w-12 h-12"
          width={24}
          height={24}
        />
        <p className="text-lg text-primary">
          {t("pages.done.contact_form.description")}
        </p>
      </div>
      <Input
        {...register("email", {
          required: t("pages.done.contact_form.validation.email_required"),
          pattern: {
            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: t("pages.done.contact_form.validation.email_invalid"),
          },
        })}
        placeholder={`${t("pages.done.contact_form.email_placeholder")} *`}
        error={formState.errors.email?.message}
      />
      <Button
        type="button"
        isLoading={isLoading}
        className="w-full mt-8"
        variant="contained"
        onClick={onSubmit}
      >
        {t("pages.done.contact_form.submit")}
      </Button>
    </form>
  );
};
